module.exports = __webpack_public_path__ + "static/media/blog_60.b1d56b59.webp";